// extracted by mini-css-extract-plugin
export default {"wrapper_title":"CategoryCardSkeleton_wrapper_title__Z0qZl","wrapper_image":"CategoryCardSkeleton_wrapper_image__oDaDL","wrapper":"CategoryCardSkeleton_wrapper__7JIAQ"};